import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, CircularProgress, Box } from '@mui/material';
import { theme } from './theme/theme';
import { Login } from './pages/Login';
import { ProtectedRoute } from './components/ProtectedRoute';
import { RoleRoute } from './components/RoleRoute';
import { Layout } from './components/layout/Layout';
import { RootRedirect } from './components/RootRedirect';
// import { OfflineIndicator } from './components/common/OfflineIndicator'; // Temporarily disabled

// Lazy load pages for code splitting (reduces initial bundle size)
const Dashboard = lazy(() => import('./pages/Dashboard').then(m => ({ default: m.Dashboard })));
const Inspections = lazy(() => import('./pages/Inspections').then(m => ({ default: m.Inspections })));
const Map = lazy(() => import('./pages/Map').then(m => ({ default: m.Map })));
const Unavailability = lazy(() => import('./pages/Unavailability').then(m => ({ default: m.Unavailability })));
const Users = lazy(() => import('./pages/Users').then(m => ({ default: m.Users })));

// Loading fallback component
const PageLoader = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
    <CircularProgress />
  </Box>
);

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {/* <OfflineIndicator /> */}
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />

          {/* Protected routes with layout */}
          <Route element={<ProtectedRoute />}>
            <Route element={<Layout />}>
              {/* Open to every authenticated role */}
              <Route path="/inspections" element={
                <Suspense fallback={<PageLoader />}>
                  <Inspections />
                </Suspense>
              } />
              <Route path="/map" element={
                <Suspense fallback={<PageLoader />}>
                  <Map />
                </Suspense>
              } />
              <Route path="/unavailability" element={
                <Suspense fallback={<PageLoader />}>
                  <Unavailability />
                </Suspense>
              } />

              {/* Dashboard: admin + inspector (staff excluded) */}
              <Route element={<RoleRoute allow={['admin', 'inspector']} />}>
                <Route path="/dashboard" element={
                  <Suspense fallback={<PageLoader />}>
                    <Dashboard />
                  </Suspense>
                } />
              </Route>

              {/* Owner-only: User Management */}
              <Route element={<RoleRoute allow={['owner']} />}>
                <Route path="/users" element={
                  <Suspense fallback={<PageLoader />}>
                    <Users />
                  </Suspense>
                } />
              </Route>

              <Route path="/" element={<RootRedirect />} />
            </Route>
          </Route>

          {/* Fallback */}
          <Route path="*" element={<RootRedirect />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
